import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import {
  cilUser,
  cilAccountLogout,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import avatar8 from './../../assets/images/avatars/userIcon.png'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks'
import { clearAuth } from '../../features/authSlice'
import { PAGE_LOGIN } from '../../PagesNames'
import { Authentication } from '../../services/Authentication/Authentication'

export const AppHeaderDropdown = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    const authentication = new Authentication();
    await authentication.logout();
    navigate(PAGE_LOGIN);
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle className="py-0" caret={false}>
        <CAvatar src={avatar8} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        {/* <CDropdownMenu className="pt-0" placement="bottom-end"> */}
        <CDropdownHeader className="bg-light fw-semibold py-2">Settings</CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href='#' onClick={() => handleLogout()}>
          <CIcon icon={cilAccountLogout} className="me-2"/>
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}
